'use strict';

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var Clone = require('@hapi/hoek/lib/clone');
var EscapeHtml = require('@hapi/hoek/lib/escapeHtml');
var Formula = require('@hapi/formula');
var Common = require('./common');
var Errors = require('./errors');
var Ref = require('./ref');
var internals = {
  symbol: Symbol('template'),
  opens: new Array(1000).join("\0"),
  closes: new Array(1000).join("\x01"),
  dateFormat: {
    date: Date.prototype.toDateString,
    iso: Date.prototype.toISOString,
    string: Date.prototype.toString,
    time: Date.prototype.toTimeString,
    utc: Date.prototype.toUTCString
  }
};
module.exports = exports = internals.Template = /*#__PURE__*/function () {
  function _class(source, options) {
    _classCallCheck(this, _class);
    Assert(typeof source === 'string', 'Template source must be a string');
    Assert(!source.includes("\0") && !source.includes("\x01"), 'Template source cannot contain reserved control characters');
    this.source = source;
    this.rendered = source;
    this._template = null;
    this._settings = Clone(options);
    this._parse();
  }
  _createClass(_class, [{
    key: "_parse",
    value: function _parse() {
      // 'text {raw} {{ref}} \\{{ignore}} {{ignore\\}} {{ignore {{ignore}'

      if (!this.source.includes('{')) {
        return;
      }

      // Encode escaped \\{{{{{

      var encoded = internals.encode(this.source);

      // Split on first { in each set

      var parts = internals.split(encoded);

      // Process parts

      var refs = false;
      var processed = [];
      var head = parts.shift();
      if (head) {
        processed.push(head);
      }
      var _iterator = _createForOfIteratorHelper(parts),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var part = _step.value;
          var raw = part[0] !== '{';
          var ender = raw ? '}' : '}}';
          var end = part.indexOf(ender);
          if (end === -1 ||
          // Ignore non-matching closing
          part[1] === '{') {
            // Ignore more than two {

            processed.push("{".concat(internals.decode(part)));
            continue;
          }
          var variable = part.slice(raw ? 0 : 1, end);
          var dynamic = this._ref(internals.decode(variable), raw);
          processed.push(dynamic);
          if (typeof dynamic !== 'string') {
            refs = true;
          }
          var rest = part.slice(end + ender.length);
          if (rest) {
            processed.push(internals.decode(rest));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!refs) {
        this.rendered = processed.join('');
        return;
      }
      this._template = processed;
    }
  }, {
    key: "describe",
    value: function describe() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this._settings && options.compact) {
        return this.source;
      }
      var desc = {
        template: this.source
      };
      if (this._settings) {
        desc.options = this._settings;
      }
      return desc;
    }
  }, {
    key: "isDynamic",
    value: function isDynamic() {
      return !!this._template;
    }
  }, {
    key: "refs",
    value: function refs() {
      if (!this._template) {
        return;
      }
      var refs = [];
      var _iterator2 = _createForOfIteratorHelper(this._template),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var part = _step2.value;
          if (typeof part !== 'string') {
            refs.push.apply(refs, _toConsumableArray(part.refs));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return refs;
    }
  }, {
    key: "resolve",
    value: function resolve(value, state, prefs, local) {
      if (this._template && this._template.length === 1) {
        return this._part(this._template[0], /* context -> [*/value, state, prefs, local, {} /*] */);
      }
      return this.render(value, state, prefs, local);
    }
  }, {
    key: "_part",
    value: function _part(part) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (part.ref) {
        var _part$ref;
        return (_part$ref = part.ref).resolve.apply(_part$ref, args);
      }
      return part.formula.evaluate(args);
    }
  }, {
    key: "render",
    value: function render(value, state, prefs, local) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      if (!this.isDynamic()) {
        return this.rendered;
      }
      var parts = [];
      var _iterator3 = _createForOfIteratorHelper(this._template),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var part = _step3.value;
          if (typeof part === 'string') {
            parts.push(part);
          } else {
            var rendered = this._part(part, /* context -> [*/value, state, prefs, local, options /*] */);
            var string = internals.stringify(rendered, prefs, options.errors);
            if (string !== undefined) {
              var result = part.raw || (options.errors && options.errors.escapeHtml) === false ? string : EscapeHtml(string);
              var ends = part.ref && part.ref.type === 'local' && part.ref.key === 'label' && prefs.errors.wrap.label;
              parts.push(internals.wrap(result, ends));
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return parts.join('');
    }
  }, {
    key: "_ref",
    value: function _ref(content, raw) {
      var _this = this;
      var refs = [];
      var reference = function reference(variable) {
        var ref = Ref.create(variable, _this._settings);
        refs.push(ref);
        return function (context) {
          return ref.resolve.apply(ref, _toConsumableArray(context));
        };
      };
      try {
        var formula = new Formula.Parser(content, {
          reference: reference,
          functions: internals.functions,
          constants: internals.constants
        });
      } catch (err) {
        err.message = "Invalid template variable \"".concat(content, "\" fails due to: ").concat(err.message);
        throw err;
      }
      if (formula.single) {
        if (formula.single.type === 'reference') {
          return {
            ref: refs[0],
            raw: raw,
            refs: refs
          };
        }
        return internals.stringify(formula.single.value);
      }
      return {
        formula: formula,
        raw: raw,
        refs: refs
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.source;
    }
  }], [{
    key: "date",
    value: function date(_date, prefs) {
      return internals.dateFormat[prefs.dateFormat].call(_date);
    }
  }, {
    key: "build",
    value: function build(desc) {
      return new internals.Template(desc.template, desc.options);
    }
  }, {
    key: "isTemplate",
    value: function isTemplate(template) {
      return template ? !!template[Common.symbols.template] : false;
    }
  }]);
  return _class;
}();
internals.Template.prototype[Common.symbols.template] = true;
internals.Template.prototype.isImmutable = true; // Prevents Hoek from deep cloning schema objects

internals.encode = function (string) {
  return string.replace(/\\(\{+)/g, function ($0, $1) {
    return internals.opens.slice(0, $1.length);
  }).replace(/\\(\}+)/g, function ($0, $1) {
    return internals.closes.slice(0, $1.length);
  });
};
internals.decode = function (string) {
  return string.replace(/\u0000/g, '{').replace(/\u0001/g, '}');
};
internals.split = function (string) {
  var parts = [];
  var current = '';
  for (var i = 0; i < string.length; ++i) {
    var char = string[i];
    if (char === '{') {
      var next = '';
      while (i + 1 < string.length && string[i + 1] === '{') {
        next += '{';
        ++i;
      }
      parts.push(current);
      current = next;
    } else {
      current += char;
    }
  }
  parts.push(current);
  return parts;
};
internals.wrap = function (value, ends) {
  if (!ends) {
    return value;
  }
  if (ends.length === 1) {
    return "".concat(ends).concat(value).concat(ends);
  }
  return "".concat(ends[0]).concat(value).concat(ends[1]);
};
internals.stringify = function (value, prefs, options) {
  var type = typeof value;
  if (value === null) {
    return 'null';
  }
  if (type === 'string') {
    return value;
  }
  if (type === 'number' || type === 'function' || type === 'symbol') {
    return value.toString();
  }
  if (type !== 'object') {
    return JSON.stringify(value);
  }
  if (value instanceof Date) {
    return internals.Template.date(value, prefs);
  }
  if (value instanceof Map) {
    var pairs = [];
    var _iterator4 = _createForOfIteratorHelper(value.entries()),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _step4$value = _slicedToArray(_step4.value, 2),
          key = _step4$value[0],
          sym = _step4$value[1];
        pairs.push("".concat(key.toString(), " -> ").concat(sym.toString()));
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    value = pairs;
  }
  if (!Array.isArray(value)) {
    return value.toString();
  }
  var partial = '';
  var _iterator5 = _createForOfIteratorHelper(value),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var item = _step5.value;
      partial = partial + (partial.length ? ', ' : '') + internals.stringify(item, prefs, options);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return internals.wrap(partial, prefs.errors.wrap.array);
};
internals.constants = {
  true: true,
  false: false,
  null: null,
  second: 1000,
  minute: 60 * 1000,
  hour: 60 * 60 * 1000,
  day: 24 * 60 * 60 * 1000
};
internals.functions = {
  if: function _if(condition, then, otherwise) {
    return condition ? then : otherwise;
  },
  msg: function msg(code) {
    var _this2 = _slicedToArray(this, 5),
      value = _this2[0],
      state = _this2[1],
      prefs = _this2[2],
      local = _this2[3],
      options = _this2[4];
    var messages = options.messages;
    if (!messages) {
      return '';
    }
    var template = Errors.template(value, messages[0], code, state, prefs) || Errors.template(value, messages[1], code, state, prefs);
    if (!template) {
      return '';
    }
    return template.render(value, state, prefs, local, options);
  },
  number: function number(value) {
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      return parseFloat(value);
    }
    if (typeof value === 'boolean') {
      return value ? 1 : 0;
    }
    if (value instanceof Date) {
      return value.getTime();
    }
    return null;
  }
};